import * as React from "react";

const CancelMark = (props: { color?: string; size?: number }): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.size ?? 24}
        height={props.size ?? 24}
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.10541 4.8335C5.39831 4.54061 5.87318 4.54061 6.16607 4.8335L11.9997 10.6671L17.8333 4.8335C18.1262 4.54061 18.6011 4.54061 18.894 4.8335C19.1869 5.12639 19.1869 5.60127 18.894 5.89416L13.0604 11.7278L18.894 17.5614C19.1869 17.8543 19.1869 18.3292 18.894 18.6221C18.6011 18.915 18.1262 18.915 17.8333 18.6221L11.9997 12.7885L6.16607 18.6221C5.87318 18.915 5.39831 18.915 5.10541 18.6221C4.81252 18.3292 4.81252 17.8543 5.10541 17.5614L10.939 11.7278L5.10541 5.89416C4.81252 5.60127 4.81252 5.12639 5.10541 4.8335Z"
            fill={props.color ?? "#E60006"}
        />
    </svg>
);

export default CancelMark;
